import { LenderData, PoolData } from '../types'
import { PoolWithMeta } from './computeLendingPools'

/**
 * Rebuilds the original nested LenderData structure from a flattened array of PoolWithMeta.
 *
 * - Groups by chainId -> lender -> poolId
 * - Removes flattened-only fields: chainId, lender, exposure, price, histPrice, utilitzation
 */
export function unflattenLenderData(pools: PoolWithMeta[]): LenderData {
  const result: LenderData = {}

  for (const pool of pools) {
    const { chainId, lender, poolId, ...rest } = pool

    // Ensure nested objects exist
    if (!result[chainId]) {
      result[chainId] = { data: {}, lastFetched: Date.now() }
    }
    if (!result[chainId].data[lender]) {
      result[chainId].data[lender] = {
        data: {},
        chainId: String(chainId),
      }
    }

    // Strip flattened-only fields
    const {
      exposure,
      price,
      histPrice,
      utilitzation,
      chainId: _c,
      lender: _l,
      ...poolData
    } = rest as any

    // Add pool back
    result[chainId].data[lender].data[poolId] = poolData as PoolData
  }

  return result
}
